import React from "react";
import {
  Beaker20Filled,
  SettingsCogMultiple20Filled,
  Save20Filled,
  SaveEdit20Filled,
} from "@fluentui/react-icons";
import CodeEditor from "./CodeEditor";

interface ScriptTabProps {
  scriptCode: string;
  setScriptCode: React.Dispatch<React.SetStateAction<string>>;
  handleSaveScript: (code: string) => void;
  handleCloseScript: () => void;
  scriptTitle?: string;
}

const ScriptTab: React.FC<ScriptTabProps> = ({
  scriptCode,
  setScriptCode,
  handleSaveScript,
  handleCloseScript,
  scriptTitle,
}) => {
  return (
    <>
      {scriptTitle && (
        <div className="text-2xl font-bold mb-4">{scriptTitle}</div>
      )}
      <div className="h-full flex flex-col flex-grow">
        {/* Action Buttons */}
        <div className="flex items-center gap-4 mb-4">
        <button className="flex items-center justify-center px-6 py-3 border border-[#F97066] rounded-lg shadow-md font-roboto font-bold text-sm text-[#F97066]">
          <Beaker20Filled className="mr-1 text-[#F97066]" />
          Test
        </button>
        <button className="flex items-center justify-center px-5 py-3 bg-[#2E90FA] rounded-lg shadow-md font-roboto font-bold text-sm text-white">
          Get Data
        </button>
        <button className="flex items-center justify-center px-6 py-3 bg-[#32D583] rounded-lg shadow-md font-roboto font-bold text-sm text-white">
          <SettingsCogMultiple20Filled className="mr-1 text-[#FC6D26]" />
          Compile
        </button>
        <div className="flex-grow"></div>
        <button
          onClick={handleCloseScript}
          className="flex items-center justify-center px-6 py-3 border border-[#6172F3] rounded-lg shadow-md font-roboto font-bold text-sm text-[#6172F3]"
        >
          <Save20Filled className="mr-1 text-[#6172F3]" />
          Cancel
        </button>
        <button
          onClick={() => handleSaveScript(scriptCode)}
          className="flex items-center justify-center px-6 py-3 bg-[#6172F3] rounded-lg shadow-md font-roboto font-bold text-sm text-white"
        >
          <SaveEdit20Filled className="mr-1 text-white" />
          Save
        </button>
      </div>

      {/* Editor */}
      <div
        className="flex-grow border border-gray-300 rounded overflow-hidden"
        style={{ height: "calc(100vh - 300px)" }}
      >
        <CodeEditor
          value={scriptCode}
          onChange={(value) => setScriptCode(value)}
          language="javascript"
          theme="vs-dark"
            height="100%"
          />
        </div>
      </div>
    </>
  );
};

export default ScriptTab;
